import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetAllBusinesses = () =>
    useQuery({
        queryKey: ["businesses"],
        queryFn: async () => {
            const response = await api.get("/api/v1/businesses");
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
    });

export const useGetBusiness = (id: string) =>
    useQuery({
        queryKey: ["businesses", id],
        queryFn: async () => {
            const response = await api.get(`/api/v1/businesses/${id}`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
    });

export const useCreateBusiness = () =>
    useMutation({
        mutationFn: async (data: { name: string; address?: string; parentBusinessId?: string | null }) => {
            const response = await api.post("/api/v1/businesses", data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["businesses"] });
        },
    });

export const useUpdateBusiness = () =>
    useMutation({
        mutationFn: async ({ id, data }: { id: string; data: { name?: string; address?: string; parentBusinessId?: string | null } }) => {
            const response = await api.put(`/api/v1/businesses/${id}`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["businesses"] });
        },
    });

export const useDeleteBusiness = () =>
    useMutation({
        mutationFn: async (id: string) => {
            const response = await api.delete(`/api/v1/businesses/${id}`);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["businesses"] });
        },
    });
